export default __webpack_public_path__ + "static/media/logo.961e8880.gif";